import { Box, Typography, Button } from "@mui/material";
import { styled } from "@mui/system";
import { useNavigate, useLocation } from "react-router-dom";

const EmptyStateContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
  width: "100%",
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.default,
  fontFamily: "Pretendard-Regular !important",
}));

const EmptyStateImage = styled("img")({
  width: "100%",
  maxWidth: "300px",
  marginBottom: "2rem",
});

const EmptyState = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const handleNavigation = () => {
    const pathParts = location.pathname.split("/");
    pathParts[pathParts.length - 1] = "plan";
    const newPath = pathParts.join("/");
    navigate(newPath);
  };
  return (
    <EmptyStateContainer>
      <EmptyStateImage
        src="/icons/process.png?height=200&width=200"
        alt="Empty state illustration"
      />
      <Typography
        variant="h4"
        gutterBottom
        sx={{ fontFamily: "Pretendard-Regular !important" }}
      >
        No Content
      </Typography>
      <Typography
        variant="body1"
        align="center"
        paragraph
        sx={{ fontFamily: "Pretendard-Regular !important" }}
      >
        <strong>AI</strong>를 이용하여 일정계힉을 생성해보세요!
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={handleNavigation}
        sx={{ fontFamily: "Pretendard-Regular !important" }}
      >
        생산계획 페이지로 이동
      </Button>
    </EmptyStateContainer>
  );
};

export default EmptyState;
